<template>
  <page class="emailConfirmation">
    <div class="emailConfirmation__content">
      <div class="emailConfirmation__content-text">
        <p>{{ $t('emailConfirmation.firstPart') }} {{ $route.query.name }},</p>
        <p>{{ $t('emailConfirmation.secondPart') }} ({{ $route.query.email }}).</p>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  name: 'EmailConfirmation'
}
</script>

<style lang="scss" scoped>
$c: '.emailConfirmation';

#{$c} {
  padding: 40px;

  p {
    font-size: 18px;
  }

  &__content {
    @include respond-above(md) {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>